<template>
  <div class="">
    <van-nav-bar
      title="认证信息"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- <div class="tab">
      <ul>
        <li @click="changecolour">
          公司
          <div :class="{ di: dis }"></div>
        </li>
        <li @click="changecolour2">
          个体工商户
          <div :class="{ di: !dis }"></div>
        </li>
      </ul>
    </div> -->
    <div
      class=""
      style="height:0.3rem"
    ></div>
    <van-form @submit="onSubmit">
      <van-field
         :value="value1"
        name="zihao"
        label="字号名称"
        readonly
      />
      <van-field
        :value="value2"
        name="jingying"
        label="经营类型"
       
        readonly
      />
     
      <van-field
        :value="value2"
        name="nashui"
        label="纳税类型"
      
         @click="showPicker2 = true"
        readonly
        
      />
      <van-field
        :value="value7"       
        type="telephone"
        name="telephone"
        label="电子邮箱"
        readonly
      />
<van-field
        :value="value6"       
        type="telephone"
        name="telephone"
        label="收件地址"
        readonly
      />
  
      
      
      <van-field
        :value="value4"
       
        type="text"
        name="name"
        label="联系人"
              readonly


      />
      <van-field
        :value="value5"       
        type="telephone"
        name="telephone"
        label="联系电话"
        readonly
      />
       
     
    </van-form>
    <div class="imgs">
      <p>营业执照</p>
    <img :src="value8" alt="">

    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import areaList from '../../assets/area'

import {
  NavBar,
  Button,
  Uploader,
  Field,
  Form,
  Checkbox,
  CheckboxGroup,
  Toast,
  Picker,
  Popup,
  Area, Dialog
} from 'vant'
Vue.use(NavBar)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Form)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Toast).use(Picker).use(Popup).use(Area).use(Dialog)
export default {
  created () {
    // console.log(this.$store.state.address)

    // this.id = this.$route.params.id
    this.axios.get('sxtinfo', { params: { } }).then(res => {
            console.log(res)
            this.value1=res.data.data.username
            this.value2=res.data.data.trade_model
            this.value3=res.data.data.tax_model
            this.value4=res.data.data.contact_name
            this.value5=res.data.data.contact_mobile
            this.value6=res.data.data.address
            this.value7=res.data.data.email
            this.value8=res.data.data.license_pic

            
            });
  },
  data () {
    return {
      petname: '',
      username: '',
      password: '',
      confirm: '',
      mobile: '',
      recommend: '', //
      address: '',
      mailbox: '',
      tlist: ["有限公司", "合伙企业", "个人独资企业", "个体工商户",'个人消费者'],
      tslist: ["增值税一般纳税人", "小规模纳税人", "其他"],
      fileList: [],
      sms: '',
      dis: true,
      checked: false,
      time: 60,
      shopid: '',
      recommendid: '',
      timetxt: '发送验证码',
      but: false,
      value: "",
      value2: "",
      recommends: '',
      tax: '',
      columns: [],
      columnsid: [],
      columns2: [],
      columns2id: [],
      showPicker: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      types: "",
      area: '',
      showArea: false,
      areaList, // 数据格式见 Area 组件文档
      userfalg: true,
      mobilefalg: true,
      imgfalge: false,
      wz: '',
      telephone: '',
      yz:[],
      value1:'',
      value2:'',
      value3:'',
      value4:'',
      value5:'',
      value6:'',
      value7:'',
      value8:'',
    }
  },
  watch: {

  },
  methods: {
    // up (e) {
    //   let file = e.target.files[0];
    //   // console.log(e.target.name)
    //   var param = new FormData(); // 创建form对象
    //   param.append("image", file, file.name);
    //   console.log(param)
    //   this.axios.post('uploadCertificate', param, {
    //     headers: { "Content-Type": "multipart/form-data" }
    //   }).then(res => {
    //     console.log(res)
    //   }).catch(ref => {
    //     console.log(ref)
    //   })
    // },
    go(){
      
  location.href="https://nmapi.huokongjian.net/api/alipay?uid="+JSON.parse(localStorage.getItem('user')).id
    },
    gotelephone (i) {
      Dialog.confirm({
        title: '电话客服',
        message: i,
        confirmButtonText: '呼叫'
      })
        .then(() => {
          // on confirm
          window.location.href = "tel:" + i
        }).catch(() => { })
    },
    panduan () {
      // console.log(1)
      if (this.username.trim() == "") {
        Toast("名称不能为空")
      } else {
        this.axios.post("usernameIsResiter", { username: this.username.trim() }).then(res => {
          if (res.data.code == 400) {
            Toast(res.data.msg)
            this.userfalg = false
          } else {
            this.userfalg = true
          }
        }).catch(ref => {
          console.log(ref)
        })
      }
    },
    panduanm () {
      // console.log(1)
      if (this.mailbox) {
        if (/^1[23456789]\d{9}$/.test(this.mailbox)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      } else {
        Toast('请输入手机号')
        return
      }
    
    },
    onArea (values) {
      this.area = values.map((item) => item.name).join('/');
      this.showArea = false;
    },
    onConfirm (value, i) {
    //   this.axios.get("getAllSalers/" + this.columnsid[i]).then(res => {
    //     this.columns2 = []
    //     this.recommends = ''
    //     this.telephone = res.data.data.store_info.store_mobile
    //     res.data.data.sale_info.forEach(v => {
    //       this.columns2.push(v.name)
    //       this.columns2id.push(v.id)
    //     })
    //   }).catch(ref => {
    //   })
      this.value = value;
      this.shopid = this.columnsid[i]
      this.showPicker = false;

    },
    onConfirm2 (value, i) {
      this.value2 = value;
      this.recommendid = this.columns2id[i]
      this.showPicker2 = false;
    },
    onConfirm3 (value, i) {
      this.types = value;
      this.showPicker3 = false;
    },
    onConfirm4 (value, i) {
      this.tax = value;
      this.showPicker4 = false;
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onSubmit (v) {
        v. store_id= this.$store.state.shopid,
        v.uploader_img=this.yz
      // console.log(v)
       if (/^1[23456789]\d{9}$/.test(this.mailbox)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      this.axios.post("sxtverify", v).then(res => {
        if (res.data.code == 2001) {
          Toast(res.data.msg)
        }
        if (res.data.code == 200) {
          Toast('提交成功，等待客服审核')
          this.$router.push('my')
        }
      }).catch(ref => {
        console.log(ref)
      })

    },

    changecolour () {
      this.dis = true
    },
    changecolour2 () {
      this.dis = false
    },
    goagreement () {
      this.$router.push('agreement')
    },
 goagreement1 () {
      this.$router.push('agreement1')
    },
    timego () {
      if (this.mobile) {
        if (/^1[23456789]\d{9}$/.test(this.mobile)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      } else {
        Toast('请输入手机号')
        return
      }
      // this.axios.post("sendSmsCode", { mobile: this.mobile }).then(res => {
      //   Toast('发送成功')
      //   this.but = true
      //   var timer = setInterval(() => {
      //     this.time--
      //     this.timetxt = '请' + this.time + '秒后发送'
      //     if (this.time === 0) {
      //       this.but = false
      //       clearInterval(timer)
      //       this.time = 60
      //       this.timetxt = '发送验证码'
      //     }
      //   }, 1000)
      // }).catch(ref => {
      //   console.log(ref)
      // })

    },
    oversize () {
      Toast('请上传10m之内的图片')

    },
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append('image', file.file)
      console.log(1)
      this.axios.post('uploadCertificate', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        file.status = 'done';
        this.yz.push(res.data.path)
        this.imgfalge = true

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
    san(i,v){
      console.log(v)
      this.yz.splice(v.index,1)
    }
  },
  components: {},
}
</script>


<style lang="less" scoped>
.top {
  width: 100%;
  height: 0.2rem;
}
.imgs{
  padding-left: 0.4rem;
  padding-top: 0.4rem;
  color: #646566;
  // width: 3rem;
  img{
    margin-left:2.35rem ;
    width: 2.5rem;
  }
}
.tab {
  ul {
    li {
      float: left;
      width: 50%;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      .di {
        width: 2rem;
        height: 0.3rem;
        background-color: #a22d2b;
        margin: 0 auto;
      }
    }
  }
}
.checkbox {
  padding-top: 0.5rem;
  padding-left: 10%;
  span {
    color: #f00;
  }
}
.van-cell__value {
  overflow: auto;
}
.tis{
    padding-left: 0.4rem;
    color: rgb(249, 124, 124);;
}
</style>
